import type { SettingsDto, SettingsUpdateDto } from '@camper-diary/shared';
import { api } from './client';

export type Settings = SettingsDto;

export function getSettings() {
  return api<Settings>('/settings');
}

export function updateSettings(input: SettingsUpdateDto) {
  return api<Settings>('/settings', { method: 'PATCH', body: input });
}
